// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import Overview from './Overview';

import './SimpleVideoBlock.scss';

export const query = graphql`
	fragment VideoBlockFragment on Ozk_pageContent {
		video_block {
			heading
			video_file {
				...AssetFragment
			}
		}
	}
`;

/**
 * @typedef SimpleVideoBlockOptions
 * @property {string} heading
 * @property {import('../CSTypes').CSFile} video_file
 *
 * @typedef SimpleVideoBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<SimpleVideoBlockOptions>} [options]
 */
/** @type {import('~/types/React').ReactFC<SimpleVideoBlockProps>} */
const SimpleVideoBlock = ({ options }) => {
	if (!options?.video_file) {
		console.error('Video file is missing');
		return (
			<pre className="container">
				There is something wrong with the video. Be sure it is published to the right environment.
			</pre>
		);
	}

	return (
		<Overview border="none">
			<div className="simple_video_block">
				<h4 {...options.$?.heading}>
					{options.heading}
				</h4>
				<br />
				<video controls>
					<source src={options.video_file.url} type="video/mp4" />
				</video>
			</div>
		</Overview>
	);
};

export default SimpleVideoBlock;
